import { FetchNotificationsOnPageChangeGlobalHandler } from '#/global-handlers/FetchNotificationsOnPageChangeGlobalHandler';
import { PageVisitCounterGlobalHandler } from '#/global-handlers/PageVisitCounterGlobalHandler';
import { QueuedTrackersGlobalHandler } from '#/global-handlers/QueuedTrackersGlobalHandler';
import { SetClientHydratedGlobalHandler } from '#/global-handlers/SetClientHydratedGlobalHandler';
import { ShowUserModalsGlobalHandler } from '#/global-handlers/ShowUserModalsGlobalHandler';
import { TrackNavigationStateGlobalHandler } from '#/global-handlers/TrackNavigationStateGlobalHandler';
import { VMOnboardingModalsExperimentGlobalHandler } from '#/global-handlers/VMOnboardingModalsExperimentGlobalHandler';

import { OverrideABExperimentsWithUrlParamsGlobalHandler } from './OverrideABExperimentsWithUrlParamsGlobalHandler';
import { UpdateSearchLocationFromLocalStorageGlobalHandler } from './UpdateSearchLocationFromLocalStorageGlobalHandler';

/*
 * Wrap app hooks to prevent them from re-rendering the whole tree
 */
export function GlobalHandlers() {
  return (
    <>
      <QueuedTrackersGlobalHandler />
      <TrackNavigationStateGlobalHandler />
      <VMOnboardingModalsExperimentGlobalHandler />
      <ShowUserModalsGlobalHandler />
      <FetchNotificationsOnPageChangeGlobalHandler />
      <PageVisitCounterGlobalHandler />
      <SetClientHydratedGlobalHandler />
      <UpdateSearchLocationFromLocalStorageGlobalHandler />
      <OverrideABExperimentsWithUrlParamsGlobalHandler />
    </>
  );
}
